const YOUTUBE_LINK_REGEX =
  /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/;

export function getVideoId(src: string) {
  const srcMatch = YOUTUBE_LINK_REGEX.exec(src);

  return srcMatch ? srcMatch[1] : null;
}
